import { FC } from 'react';
import { Text, Button, Flex, useBreakpoint } from '@servicetitan/anvil2';

import { usePanelDialog } from '../manage-tenant-layout/panel-dialog-context';
import { BREAKPOINTS_SMALLER_LG } from '../../utils/ux';

import * as Styles from './title-with-open-details.module.less';

interface TitleWithOpenDetailsProps {
    title?: string;
}

export const TitleWithOpenDetails: FC<TitleWithOpenDetailsProps> = ({ title }) => {
    const breakpoint = useBreakpoint();
    const isDialogMode = BREAKPOINTS_SMALLER_LG.includes(breakpoint?.name ?? '');
    const { panelDialogState, setPanelDialogState, hasPanel } = usePanelDialog();

    if (!title) {
        return null;
    }

    const showOpenButton = hasPanel && isDialogMode && !panelDialogState;

    return (
        <Flex justifyContent="space-between" alignItems="center" className={Styles.titleContainer}>
            <Text variant="headline" el="h3" className="m-b-0-i">
                {title}
            </Text>
            {showOpenButton && (
                <Button onClick={() => setPanelDialogState(true)} size="small">
                    View Details
                </Button>
            )}
        </Flex>
    );
};
